// extracted by mini-css-extract-plugin
module.exports = {"styledIcon":"w496kHyY","enableHover":"wtib1iKQ","isDisabled":"gROpgBvT"};